import type { RootState } from 'modules/reducers';

export const getCurrentLocale = (state: RootState) => state.locale.current;
export const selectIsLocaleInitialized = (state: RootState) => state.locale.initialized;
